import subscriptions from '@/store/modules/dashboard/payments/subscriptions';
import transactions from '@/store/modules/dashboard/payments/transactions';
import freeSubscriptions from '@/store/modules/dashboard/payments/free-subscriptions';

export default {
  namespaced: true,
  modules: {
    subscriptions,
    transactions,
    freeSubscriptions,
  },
};
